import { useMutation } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import {
  addTableItem,
  updateTableItem,
  deleteTableItem,
} from "../Services/tableItemMutations";
import { useInvalidateTableItems } from "./useTableItemsQuery";

export function useAddTableItemMutation() {
  const { accessToken } = useAuth();
  const invalidate = useInvalidateTableItems();

  return useMutation({
    mutationFn: ({ item, tableName }) => addTableItem({ item, tableName, accessToken }),
    onSuccess: (_, { tableName, countryId }) => invalidate(tableName, countryId),
  });
}

export function useUpdateTableItemMutation() {
  const { accessToken } = useAuth();
  const invalidate = useInvalidateTableItems();

  return useMutation({
    mutationFn: ({ item, tableName }) => updateTableItem({ item, tableName, accessToken }),
    onSuccess: (_, { tableName, countryId }) => invalidate(tableName, countryId),
  });
}

export function useDeleteTableItemMutation() {
  const { accessToken } = useAuth();
  const invalidate = useInvalidateTableItems();

  return useMutation({
    mutationFn: ({ item, tableName }) => deleteTableItem({ item, tableName, accessToken }),
    onSuccess: (_, { tableName, countryId }) => invalidate(tableName, countryId),
  });
}